import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider';
import AuthHeader from './components/AuthHeader';
import AuthTabs from './components/AuthTabs';
import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
import AuthFeatures from './components/AuthFeatures';
import Seo from '../../components/Seo';

const LoginRegistration = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('login');

  useEffect(() => {
    if (loading) return;
    if (user) {
      navigate('/project-dashboard');
    }
  }, [loading, navigate, user]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 md:p-6 lg:p-8">
      <Seo title="로그인" canonicalPath="/login-registration" />
      <div className="w-full max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <div className="flex flex-col justify-center">
            <AuthHeader />
            
            <div className="bg-card rounded-lg shadow-gaming-lg p-6 md:p-8 lg:p-10 border border-border">
              <AuthTabs activeTab={activeTab} onTabChange={setActiveTab} />
              
              {activeTab === 'login' ? <LoginForm /> : <RegisterForm />}
            </div>

            <div className="mt-6 md:mt-8 text-center">
              <p className="text-xs md:text-sm text-muted-foreground caption">
                © {new Date()?.getFullYear()} kkumhyeonlabs. All rights reserved.
              </p>
            </div>
          </div>

          <div className="hidden lg:flex flex-col justify-center">
            <div className="space-y-6 lg:space-y-8">
              <div>
                <h2 className="text-2xl lg:text-3xl font-heading font-bold text-foreground mb-3 lg:mb-4">
                  게임처럼 즐기는 목표 달성
                </h2>
                <p className="text-base lg:text-lg text-muted-foreground leading-relaxed">
                  단순한 할 일 목록을 넘어서, 목표 달성을 게임처럼 즐길 수 있는 서비스입니다. 이미지 기반 증명 시스템으로 성취를 시각적으로 기록하고, 별점과 업적을 수집하며 성장하세요.
                </p>
              </div>

              <AuthFeatures />

              <div className="flex items-center space-x-4 p-6 bg-primary/10 rounded-lg border border-primary/20">
                <div className="flex-shrink-0 w-12 h-12 bg-primary/20 rounded-md flex items-center justify-center">
                  <span className="text-2xl font-bold text-primary data-text">30</span>
                </div>
                <div className="flex-1">
                  <div className="text-sm font-medium text-foreground mb-1">
                    30일 챌린지 시스템
                  </div>
                  <div className="text-xs text-muted-foreground caption">
                    매일 증명을 제출하고 습관을 만들어보세요
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginRegistration;